import GuidedPromptPart from './parts/guided-prompt-part';
import ChartPart from './parts/chart-part';
import TextPart from './parts/text-part';

import { PART_TYPES } from '../../ai-assistant.constants';

export type RenderContext = 'inline' | 'input';

export interface PartRegistryEntry {
  component: typeof TextPart | typeof ChartPart | typeof GuidedPromptPart;
  renderContext: RenderContext;
}

export interface InlinePartRendererProps {
  data: unknown;
}

/** renderContext: 'inline' = inside message bubble, 'input' = replaces message input. */
export const PART_REGISTRY: Partial<Record<string, PartRegistryEntry>> = {
  [PART_TYPES.MESSAGE]: {
    component: TextPart,
    renderContext: 'inline',
  },
  [PART_TYPES.GUIDED_PROMPT]: {
    component: GuidedPromptPart,
    renderContext: 'input',
  },
  [PART_TYPES.CHART]: {
    component: ChartPart,
    renderContext: 'inline',
  },
};
